import { lazy, Suspense } from 'react';

const LazyDriverRegister = lazy(() => import('./DriverRegister'));

const DriverRegister = () => (
  <Suspense fallback={null}>
    <LazyDriverRegister />
  </Suspense>
);

export default DriverRegister;
